import React from "react";
import { PieceInfoGroupProps } from "./pieceInfoGroup";
import Keywords from "../../../components/piece/keywords";

export default function KeywordsPieceInfoGroup(props: PieceInfoGroupProps) {
    if(props.piece.keywords.size === 0) return <></>;
    return <>
        <h4>Keywords</h4>
        <Keywords keywords={Array.from(props.piece.keywords)} />
    </>;
}